module.exports = __webpack_public_path__ + "img/img02.cb3f20be.jpg";